import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRotateRight, faThumbtack, faClose, faPaperclip } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, useRef } from "react";
import axios from 'util/axios';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import DownloadDiv from "util/component/Download";

import Pagination, { SetPager } from "util/component/Pagination/v2";

const VIEW_PAGE = 6;

const Notice = (props, ref) => {
    const [List, SetList] = useState([]);
    const [Loading, SetLoading] = useState(true);
    const [ShowNotice, SetShowNotice] = useState(null);
    const userSelector = useSelector((store) => store.user);
    const { t } = useTranslation(["page"]);

    const TBL_DATA_ORIGIN = useRef([]);
    const [PAGER, SetPAGER] = useState(null);

    const getList = async () => {
        SetLoading(true);
        try {
            
            let response = await axios.post(process.env.REACT_APP_API + "/notice/retrieveNoticeList").then((Response) => Response.data.data.result);
            response = response?.filter((f) => {
                
                if(userSelector.isExternal) {
                    return f.target.includes("E") || !f.target;
                } else {
                    return f.target.includes("I") || !f.target;
                }
                
            }) || []
            TBL_DATA_ORIGIN.current = response || [];
            const pager = new SetPager(TBL_DATA_ORIGIN.current.length, VIEW_PAGE);
            SetPAGER({ data: pager });
        } catch (e) {
            SetList([]);
        } finally {
            SetLoading(false);
        }
    };

    const getNotice = async (noticeId) => {
        const response = await axios.post(process.env.REACT_APP_API + "/notice/retrieveNotice", { noticeId: noticeId }).then((Response) => Response.data.data.result);
        SetShowNotice(response);
    };

    useEffect(() => {
        if (!PAGER) return;
        const range = PAGER.data.getItemRange();
        let setData = [];
        for (let i = range.start; i < range.end; i++) {
            setData.push(TBL_DATA_ORIGIN.current[i]);
        }
        SetList(setData);
    }, [PAGER]);

    useEffect(() => {
        getList();
        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    return (
        <div className={"position-relative"}>
            <div className={"refresh-btn"} onClick={getList}>
                <FontAwesomeIcon icon={faArrowRotateRight} />
            </div>
            <table className={"bpl-table-default small compact has-pagination fixed"} style={{ fontSize: "0.9rem" }}>
                <colgroup>
                    <col />
                    <col width="100" />
                </colgroup>
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {!Loading && List.length > 0 ? (
                        List?.map((rowData, index) => {
                            const { noticeId, noticeTitle, fixYn, createDt } = rowData;
                            return (
                                <tr
                                    key={`myNoticeList${index}`}
                                    className={"clickable"}
                                    onClick={() => {
                                        getNotice(noticeId);
                                    }}
                                >
                                    <td className={"noticeFixed"}>
                                        {noticeTitle} {fixYn && <FontAwesomeIcon icon={faThumbtack} />}
                                    </td>
                                    <td className={"text-center"}>{createDt}</td>
                                </tr>
                            );
                        })) : (
                            <tr>
                                <td colSpan={2} className={"text-center"}>
                                    No Results
                                </td>
                            </tr>
                        )
                    }
                    
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="2">
                            <Pagination data={PAGER?.data} v2 set={(data) => SetPAGER({ data: data, refresh: new Date() })} />
                        </td>
                    </tr>
                </tfoot>
            </table>
            <div className={`safearea-modal notice-modal ${ShowNotice !== null ? "" : "hide"}`}>
                <div className={`notice-content ${ShowNotice?.fileNm ? "file-exist" : ""}`}>
                    <div className={`notice-content-wrapper`}>
                        <div className={"notice-content-closebtn"} onClick={() => SetShowNotice(null)}>
                            <FontAwesomeIcon icon={faClose} />
                        </div>
                        <div className={"notice-content-header"}>
                            <h4>{ShowNotice?.noticeTitle} {ShowNotice?.fixYn && <FontAwesomeIcon icon={faThumbtack} />}</h4>
                            <p className={"sub-info"}>
                                {ShowNotice?.createDt} <span className={"italic"}>Written by</span> <span>{ShowNotice?.userNm}</span>
                            </p>
                        </div>
                        <div className={"notice-content-body"}>
                            <div dangerouslySetInnerHTML={{ __html: ShowNotice?.noticeContent }} />
                        </div>
                        <div className={"notice-content-footer"}>
                            {ShowNotice?.fileNm && (
                                <div className={"d-flex align-center full-div auto"}>
                                    <div className={"file-title"}><FontAwesomeIcon icon={faPaperclip} /></div>
                                    <div>
                                        <DownloadDiv to={{ api: "/notice/downloadFile", body: { code: ShowNotice?.noticeId, name: ShowNotice?.fileNm } }}>{ShowNotice?.fileNm}</DownloadDiv>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Notice;
